'use es6';

import createReactClass from 'create-react-class';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIRouterLink from 'ui-addon-react-router/UIRouterLink';
import CategoryDropdown from '../components/CategoryDropdown';
import CategoryNavigation from '../components/CategoryNavigation';
import FeatureOptions from '../constants/FeatureOptions';
import GoodFiltersAndPage from '../constants/GoodFiltersAndPage';
import GoodSubTypes from '../constants/GoodSubTypes';
import ModulePurposeOptions from '../constants/CustomModulePurposeOptions';
import { requestStatusPropType } from '../constants/propTypes/requestStatus';
import IndustryDropdown from '../components/IndustryDropdown';
import TemplatePurposeDropdown from '../components/TemplatePurposeDropdown';
import MultiselectCheckboxFilter from '../components/MultiselectCheckboxFilter';
import MultiselectDropdownFilter from '../components/MultiselectDropdownFilter';
import ProviderDropdown from '../components/ProviderDropdown';
import PageLayoutFilter from '../components/PageLayoutFilter';
import * as GoodsActions from '../actions/GoodsActions';
import { getCategoryMenuOptions } from '../utils/sidebarUtils';
import { getSortedSelectedFilters, getCategoryOptionText } from '../utils/langUtils';
import { getProviderNames, getProvidersRequestStatus } from '../selectors/providers';
var DirectorySidebarContainer = createReactClass({
  displayName: "DirectorySidebarContainer",
  mixins: [PureRenderMixin],
  propTypes: {
    allProviders: PropTypes.array.isRequired,
    categoryFilter: PropTypes.string.isRequired,
    childTypeFilters: PropTypes.instanceOf(Immutable.List).isRequired,
    codingTypeFilters: PropTypes.instanceOf(Immutable.List).isRequired,
    fetchProviders: PropTypes.func.isRequired,
    moduleCompatibilityFilter: PropTypes.instanceOf(Immutable.List).isRequired,
    modulePurposeFilter: PropTypes.instanceOf(Immutable.List).isRequired,
    onGoodFilterChange: PropTypes.func.isRequired,
    priceFilters: PropTypes.instanceOf(Immutable.List).isRequired,
    industryFilter: PropTypes.string.isRequired,
    featureFilters: PropTypes.instanceOf(Immutable.List).isRequired,
    pageLayoutFilter: PropTypes.string.isRequired,
    providerFilter: PropTypes.string,
    providersRequestStatus: requestStatusPropType.isRequired,
    templatePurposeFilter: PropTypes.string.isRequired,
    trackAdjustedFilter: PropTypes.func.isRequired,
    trackLinkClick: PropTypes.func.isRequired,
    trackMultiselectSelection: PropTypes.func.isRequired
  },
  renderCustomModulePurposeFilter: function renderCustomModulePurposeFilter() {
    var _this$props = this.props,
        categoryFilter = _this$props.categoryFilter,
        modulePurposeFilter = _this$props.modulePurposeFilter,
        onGoodFilterChange = _this$props.onGoodFilterChange;

    if (categoryFilter !== GoodSubTypes.CUSTOM_MODULE) {
      return null;
    }

    var sortedModulePurposeFilters = getSortedSelectedFilters(GoodFiltersAndPage.MODULE_PURPOSE, modulePurposeFilter);
    return React.createElement(MultiselectDropdownFilter, {
      className: "integrate-module-function-filter",
      defaultOption: ModulePurposeOptions.NONE,
      filterType: GoodFiltersAndPage.MODULE_PURPOSE,
      maxSelections: 3,
      onGoodFilterChange: onGoodFilterChange,
      selectedFilters: sortedModulePurposeFilters,
      trackMultiselectSelection: this.props.trackMultiselectSelection
    });
  },
  renderCustomModuleCompatibilityFilter: function renderCustomModuleCompatibilityFilter() {
    var _this$props2 = this.props,
        categoryFilter = _this$props2.categoryFilter,
        moduleCompatibilityFilter = _this$props2.moduleCompatibilityFilter,
        onGoodFilterChange = _this$props2.onGoodFilterChange,
        trackMultiselectSelection = _this$props2.trackMultiselectSelection;

    if (categoryFilter !== GoodSubTypes.CUSTOM_MODULE) {
      return null;
    }

    return React.createElement(MultiselectCheckboxFilter, {
      className: "integrate-module-compatibility-filter",
      filterName: GoodFiltersAndPage.MODULE_COMPATIBILITY,
      filtersCurrentlyAppliedInComponent: moduleCompatibilityFilter,
      onGoodFilterChange: onGoodFilterChange,
      showSelectAll: true,
      trackMultiselectSelection: trackMultiselectSelection
    });
  },
  renderEmailCodingTypeFilter: function renderEmailCodingTypeFilter() {
    var _this$props3 = this.props,
        categoryFilter = _this$props3.categoryFilter,
        codingTypeFilters = _this$props3.codingTypeFilters,
        onGoodFilterChange = _this$props3.onGoodFilterChange,
        trackMultiselectSelection = _this$props3.trackMultiselectSelection;

    if (categoryFilter !== GoodSubTypes.EMAIL_TEMPLATES) {
      return null;
    }

    return React.createElement(MultiselectCheckboxFilter, {
      filterName: GoodFiltersAndPage.CODING_TYPE,
      filtersCurrentlyAppliedInComponent: codingTypeFilters,
      onGoodFilterChange: onGoodFilterChange,
      trackMultiselectSelection: trackMultiselectSelection
    });
  },
  renderPackChildTypeFilter: function renderPackChildTypeFilter() {
    var _this$props4 = this.props,
        categoryFilter = _this$props4.categoryFilter,
        childTypeFilters = _this$props4.childTypeFilters,
        onGoodFilterChange = _this$props4.onGoodFilterChange,
        trackMultiselectSelection = _this$props4.trackMultiselectSelection;

    if (categoryFilter !== GoodSubTypes.PACKS) {
      return null;
    }

    var sortedChildTypeFilters = getSortedSelectedFilters(GoodFiltersAndPage.CHILD_TYPES, childTypeFilters);
    return React.createElement(MultiselectCheckboxFilter, {
      className: "integrate-pack-child-type-filter",
      filterName: GoodFiltersAndPage.CHILD_TYPES,
      filtersCurrentlyAppliedInComponent: sortedChildTypeFilters,
      onGoodFilterChange: onGoodFilterChange,
      trackMultiselectSelection: trackMultiselectSelection
    });
  },
  renderTemplateFilters: function renderTemplateFilters() {
    var _this$props5 = this.props,
        categoryFilter = _this$props5.categoryFilter,
        featureFilters = _this$props5.featureFilters,
        onGoodFilterChange = _this$props5.onGoodFilterChange,
        pageLayoutFilter = _this$props5.pageLayoutFilter,
        templatePurposeFilter = _this$props5.templatePurposeFilter;

    if (categoryFilter === GoodSubTypes.ALL || categoryFilter === GoodSubTypes.PACKS || categoryFilter === GoodSubTypes.CUSTOM_MODULE || categoryFilter === GoodSubTypes.CMS_THEME) {
      return null;
    }

    var sortedFeatureFilters = getSortedSelectedFilters(GoodFiltersAndPage.FEATURES, featureFilters);
    return React.createElement(Fragment, null, React.createElement(TemplatePurposeDropdown, {
      onGoodFilterChange: onGoodFilterChange,
      templatePurposeFilter: templatePurposeFilter
    }), this.renderEmailCodingTypeFilter(), React.createElement(PageLayoutFilter, {
      onGoodFilterChange: onGoodFilterChange,
      pageLayoutFilter: pageLayoutFilter
    }), React.createElement(MultiselectDropdownFilter, {
      defaultOption: FeatureOptions.NONE,
      filterType: GoodFiltersAndPage.FEATURES,
      maxSelections: 3,
      onGoodFilterChange: onGoodFilterChange,
      selectedFilters: sortedFeatureFilters,
      trackMultiselectSelection: this.props.trackMultiselectSelection
    }));
  },
  renderIndustryFilter: function renderIndustryFilter() {
    var _this$props6 = this.props,
        categoryFilter = _this$props6.categoryFilter,
        industryFilter = _this$props6.industryFilter,
        onGoodFilterChange = _this$props6.onGoodFilterChange;

    if (categoryFilter === GoodSubTypes.ALL || categoryFilter === GoodSubTypes.CUSTOM_MODULE) {
      return null;
    }

    return React.createElement(IndustryDropdown, {
      onGoodFilterChange: onGoodFilterChange,
      industryFilter: industryFilter
    });
  },
  renderPriceFilter: function renderPriceFilter() {
    var _this$props7 = this.props,
        priceFilters = _this$props7.priceFilters,
        onGoodFilterChange = _this$props7.onGoodFilterChange,
        trackMultiselectSelection = _this$props7.trackMultiselectSelection;
    return React.createElement(MultiselectCheckboxFilter, {
      className: "integrate-price-filter",
      filterName: GoodFiltersAndPage.PRICE,
      filtersCurrentlyAppliedInComponent: priceFilters,
      onGoodFilterChange: onGoodFilterChange,
      trackMultiselectSelection: trackMultiselectSelection
    });
  },
  renderSidebarTitle: function renderSidebarTitle() {
    var menuParent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var _this$props8 = this.props,
        categoryFilter = _this$props8.categoryFilter,
        trackLinkClick = _this$props8.trackLinkClick;

    if (categoryFilter === GoodSubTypes.ALL) {
      return React.createElement("h5", null, React.createElement(FormattedMessage, {
        message: "sidebar.title"
      }));
    } else {
      return React.createElement("h5", null, React.createElement(UIRouterLink, {
        className: "integrate-back-to-products",
        onClick: trackLinkClick.bind(null, "back-to-home-from-" + categoryFilter),
        to: '/products'
      }, React.createElement(FormattedMessage, {
        message: "MarketplaceUI.directory.sidebar.multiselectCheckboxFilter.all"
      })), React.createElement(UIIcon, {
        name: "right",
        className: "m-x-1"
      }), getCategoryOptionText(menuParent));
    }
  },
  renderSubmenu: function renderSubmenu(menuOptions) {
    var _this$props9 = this.props,
        categoryFilter = _this$props9.categoryFilter,
        onGoodFilterChange = _this$props9.onGoodFilterChange,
        trackAdjustedFilter = _this$props9.trackAdjustedFilter,
        trackLinkClick = _this$props9.trackLinkClick;

    if (categoryFilter === GoodSubTypes.ALL) {
      return React.createElement(CategoryDropdown, {
        categoryFilter: categoryFilter,
        onGoodFilterChange: onGoodFilterChange
      });
    }

    return React.createElement(CategoryNavigation, Object.assign({
      categoryFilter: categoryFilter,
      trackAdjustedFilter: trackAdjustedFilter,
      trackLinkClick: trackLinkClick
    }, menuOptions));
  },
  renderProviders: function renderProviders() {
    var _this$props10 = this.props,
        allProviders = _this$props10.allProviders,
        fetchProviders = _this$props10.fetchProviders,
        onGoodFilterChange = _this$props10.onGoodFilterChange,
        providerFilter = _this$props10.providerFilter,
        providersRequestStatus = _this$props10.providersRequestStatus;
    return React.createElement("div", {
      className: "m-y-4"
    }, React.createElement(ProviderDropdown, {
      allProviders: allProviders,
      fetchProviders: fetchProviders,
      onGoodFilterChange: onGoodFilterChange,
      providerFilter: providerFilter,
      providersRequestStatus: providersRequestStatus
    }));
  },
  render: function render() {
    var categoryFilter = this.props.categoryFilter;
    var menuOptions = getCategoryMenuOptions(categoryFilter);
    return React.createElement(Fragment, null, this.renderSidebarTitle(menuOptions.parent), this.renderSubmenu(menuOptions), this.renderPriceFilter(), this.renderPackChildTypeFilter(), this.renderCustomModulePurposeFilter(), this.renderCustomModuleCompatibilityFilter(), this.renderTemplateFilters(), this.renderIndustryFilter(), this.renderProviders());
  }
});

function mapStateToProps(state) {
  var goodFilters = state.directoryData.get('goodFiltersAndPage');
  return {
    allProviders: getProviderNames(state),
    categoryFilter: goodFilters.get(GoodFiltersAndPage.SUB_TYPE),
    childTypeFilters: goodFilters.get(GoodFiltersAndPage.CHILD_TYPES),
    codingTypeFilters: goodFilters.get(GoodFiltersAndPage.CODING_TYPE),
    priceFilters: goodFilters.get(GoodFiltersAndPage.PRICE),
    industryFilter: goodFilters.get(GoodFiltersAndPage.INDUSTRY),
    featureFilters: goodFilters.get(GoodFiltersAndPage.FEATURES),
    pageLayoutFilter: goodFilters.get(GoodFiltersAndPage.PAGE_LAYOUT),
    templatePurposeFilter: goodFilters.get(GoodFiltersAndPage.TEMPLATE_PURPOSE),
    moduleCompatibilityFilter: goodFilters.get(GoodFiltersAndPage.MODULE_COMPATIBILITY),
    modulePurposeFilter: goodFilters.get(GoodFiltersAndPage.MODULE_PURPOSE),
    providerFilter: goodFilters.get(GoodFiltersAndPage.PROVIDER),
    providersRequestStatus: getProvidersRequestStatus(state)
  };
}

var mapDispatchToProps = {
  fetchProviders: GoodsActions.getProviderNames,
  trackMultiselectSelection: GoodsActions.trackMultiselectSelection
};
export default connect(mapStateToProps, mapDispatchToProps)(DirectorySidebarContainer);